import { VueModule } from '@Foundation/utilities';
import AccessibilityModalWindow from './code/Scripts/components/accessibility-modal-window';

export default VueModule({
  components: {
    AccessibilityModalWindow
  }
});